module.exports = __webpack_public_path__ + "img/V10.566790fd.jpg";